// api/user.js
import request from "@/utils/request.js"

// 基本信息
export function getCompanyBase() {
    return request({
        url: '/getCompanyBase',
        method: 'get',
    })
}

// 时间线
export function getCompanyTime() {
    return request({
        url: '/getCompanyTime',
        method: 'get',
    })
}

// 资质证书
export function getCompanyCert() {
    return request({
        url: '/getCompanyCert',
        method: 'get',
    })
}